import { Pipe, PipeTransform } from '@angular/core';
import { usdToPoints } from '@models';

@Pipe({
  name: 'priceInPoints',
  pure: true,
  standalone: true,
})
export class PriceInPointsPipe implements PipeTransform {
  transform(priceUsd: number): number {
    if (!priceUsd) return 0;
    return usdToPoints(priceUsd);
  }
}
